import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { useEnterprisePermittedProducts } from 'bundles/unified-common/contexts/EnterprisePermittedProductsContext';
import { useIsWildcard } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const useIsLimitedContent = () => {
  const isOrgScopedHome = GrowthDiscoveryEpicClient.preview('orgScopedHome');
  const isWildcard = useIsWildcard(); // program level full catalog
  const enterprisePermittedProducts = useEnterprisePermittedProducts(); // org level limitation

  return enterprisePermittedProducts?.isProgramLimitedContent || (!isOrgScopedHome && !isWildcard);
};

export default useIsLimitedContent;
